var _style, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgListWithDot = function SvgListWithDot(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgListWithDot",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.svgListWithDot{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_123456",
    className: "svgListWithDot svgBase svgHover svgSelect",
    d: "M2.6,5.3c1,0,1.9-0.6,2.2-1.5h10.4c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c0,0,0,0,0,0H5 C4.8,1.3,3.6,0.3,2.3,0.5S0,1.9,0.2,3.2C0.4,4.4,1.4,5.3,2.6,5.3L2.6,5.3z M2.6,1.7c0.7,0,1.2,0.5,1.2,1.2S3.2,4.1,2.6,4.1 S1.4,3.5,1.4,2.9v0C1.4,2.2,1.9,1.7,2.6,1.7C2.6,1.7,2.6,1.7,2.6,1.7L2.6,1.7z M15.2,10.7H5c0,0-0.1,0-0.1,0C4.6,9.4,3.3,8.7,2,9 c-1.3,0.3-2.1,1.6-1.7,2.9c0.3,1.3,1.6,2.1,2.9,1.7c0.9-0.2,1.5-0.9,1.7-1.7c0,0,0.1,0,0.1,0h10.2c0.3,0,0.6-0.3,0.6-0.6 S15.6,10.7,15.2,10.7C15.2,10.7,15.2,10.7,15.2,10.7L15.2,10.7z M2.6,12.5c-0.7,0-1.2-0.5-1.2-1.2s0.5-1.2,1.2-1.2s1.2,0.5,1.2,1.2 v0C3.8,12,3.2,12.5,2.6,12.5C2.6,12.5,2.6,12.5,2.6,12.5L2.6,12.5z M15.2,6.5H9.8c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6h5.4 c0.3,0,0.6-0.3,0.6-0.6C15.8,6.8,15.6,6.5,15.2,6.5z M15.2,14.3H9.8c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6h5.4 c0.3,0,0.6-0.3,0.6-0.6S15.6,14.3,15.2,14.3C15.2,14.3,15.2,14.3,15.2,14.3z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgListWithDot, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/list_with_dot.827feea9.svg";
export { ForwardRef as ReactComponent };